import { CalculatorForm } from "../components";
import Strings from "../strings/strings";

import styles from "./styles/calculatorSection.module.scss";

export const CalculatorSection = () => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <span className={styles.title}>{Strings.airQualityTitle}</span>
          <span className={styles.text}>{Strings.airQualitySubtitle}</span>
        </div>
        <div>{CalculatorForm()}</div>
      </div>
    </>
  );
};
